import { fnv1a64Hex } from 'utils/fnv1a';

/**
 * Mirrors hashHandHistoryPlayerId in
 * serverless-v2/shared/handHistorySnapshot/builder.js.
 *
 * The public hand-history CDN document strips every seat's and pot-award
 * player's real account GUID and replaces it with a pseudonymous, per-table
 * digest. An authenticated client that already knows its own GUID recomputes
 * the identical value here to find its own seat (see
 * attachViewerSeatToCompletedHands in HandHistoryContext.tsx), without the
 * GUID ever appearing in the public document.
 *
 * This MUST stay byte-for-byte identical to the server's algorithm — same
 * input string, same hash, same truncation — or a client can never match its
 * own seat. See utils/fnv1a.ts for why this is FNV-1a and synchronous rather
 * than an async Web Crypto digest.
 */
export function computeHandHistoryPlayerId(gameId: string, playerGuid: string): string {
  return fnv1a64Hex(`hand-history:${gameId}:${playerGuid}`);
}
